import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { memo as C, useRef as P, useState as N, useEffect as m } from "react";
import { clsx as d } from "../../../node_modules/clsx/dist/clsx.m.js";
import { useFloating as O, useDismiss as R, useInteractions as k, FloatingFocusManager as y, FloatingPortal as E, FloatingArrow as A } from "../../../node_modules/@floating-ui/react/dist/floating-ui.react.js";
import f from "./Popover.module.scss.js";
import { offset as I, arrow as M } from "../../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
import { autoUpdate as S } from "../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
const D = (t) => {
  const {
    open: s,
    children: g,
    trigger: u,
    className: p,
    classNameTrigger: h,
    showArrow: x = !0,
    disabledFocus: b = !1,
    disableCloseOut: i = !1,
    position: F = "bottom-start",
    backgroundColor: n = "var(--ds-base-color-actionable-destructive-fg)"
  } = t, a = P(null), [o, l] = N(s), { refs: c, floatingStyles: j, context: r } = O({
    open: s,
    onOpenChange: l,
    placement: F,
    middleware: [I(10), M({ element: a })],
    whileElementsMounted: S
  }), v = R(r, {
    outsidePress: !i
  }), { getFloatingProps: w } = k([v]);
  return m(() => {
    s && !o && !i && t.onClose();
  }, [o]), m(() => {
    l(s), !s && o && t.onClose();
  }, [s]), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      "div",
      {
        ref: c.setReference,
        className: d(f.trigger, h),
        children: u
      }
    ),
    o && /* @__PURE__ */ e.jsx(
      y,
      {
        context: r,
        disabled: b,
        children: /* @__PURE__ */ e.jsx(E, { children: /* @__PURE__ */ e.jsxs(
          "div",
          {
            ref: c.setFloating,
            style: { ...j, backgroundColor: n },
            className: d(f.popover, p),
            ...w(),
            children: [
              x && /* @__PURE__ */ e.jsx(
                A,
                {
                  ref: a,
                  strokeWidth: 1,
                  context: r,
                  fill: n,
                  stroke: "var(--ds-base-color-containers-white-border)"
                }
              ),
              g
            ]
          }
        ) })
      }
    )
  ] });
}, G = C(D);
export {
  G as default
};
//# sourceMappingURL=Popover.js.map
